import { render } from "./MessengerKeyBackupModal.vue?vue&type=template&id=56f70910&scoped=true&ts=true"
import script from "./MessengerKeyBackupModal.vue?vue&type=script&lang=ts"
export * from "./MessengerKeyBackupModal.vue?vue&type=script&lang=ts"

import "./MessengerKeyBackupModal.vue?vue&type=style&index=0&id=56f70910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f70910"]])

export default __exports__